import GovernmentBondBenchmark from "./GovernmentBondBenchmark";
import ReferenceRate from "./ReferenceRate";
import SwapBenchmark from "./SwapBenchmark";
import FutureBenchmark from "./FutureBenchmark";
class GenericBenchmark {
    governmentBond;
    interestRate;
    swap;
    future;
    constructor(response) {
        this.future = response.future !== undefined ? new FutureBenchmark(response.future) : undefined;
        this.swap = response.swap !== undefined ? new SwapBenchmark(response.swap) : undefined;
        this.governmentBond = response.governmentBond !== undefined ? new GovernmentBondBenchmark(response.governmentBond) : undefined;
        this.interestRate = response.interestRate !== undefined ? new ReferenceRate(response.interestRate) : undefined;
    }
    print() {
        if (this.swap !== undefined) {
            return this.swap.printShort();
        }
        if (this.governmentBond !== undefined) {
            return this.governmentBond.printShort();
        }
        if (this.interestRate !== undefined) {
            return this.interestRate.printShort();
        }
        if (this.future !== undefined) {
            return this.future.printShort();
        }
        return undefined;
    }
    ;
}
export default GenericBenchmark;
